module.exports = __webpack_public_path__ + "static/img/dxsf.c672a95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hot-back/dxsf.png
// module id = nCkO
// module chunks = 1